import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import { useIsOpen } from "../hooks";
export var withOpeningWrapper = function withOpeningWrapper(WrappedComponent) {
  return /*#__PURE__*/memo(function (props) {
    var _useIsOpen = useIsOpen(),
      isOpen = _useIsOpen.isOpen,
      handleClose = _useIsOpen.handleClose,
      handleToggle = _useIsOpen.handleToggle;
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
      isOpen: isOpen,
      onClose: handleClose,
      onToggle: handleToggle,
      "data-t-id": "Select-hocs"
    }));
  });
};